import { ProfileCardDescription, useDialogHistoryManager } from "./styles/components/ProfileCardDescription/ProfileCardDescription.mjs";
import { DefinitionList } from "./styles/components/DefinitionList/DefinitionList.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
import { VerificationLogo, SeekPassIconVerified } from "@seek/certsy-ui";
import { useTranslations } from "@vocab/react";
import { Dialog, Stack, Text, Actions, ButtonLink, IconNewWindow, Button, Box, Inline, IconLicence, IconMoney, IconProfile, TextLink, TooltipRenderer, Bleed } from "braid-design-system";
import { useCallback } from "react";
import { translations } from "./components/CertsyDialog/.vocab/index.mjs";
import { useGetUrl } from "@seek/ca-myprofile-utils";
import { translations as translations$1 } from "./components/ResumeSensitiveDialog/.vocab/index.mjs";
import { translations as translations$2 } from "./components/CertsyVerifiedIndicator/.vocab/index.mjs";
const CertsyDialog = ({
  onClose,
  certsyUrl,
  onCertsyClick,
  bodyText,
  certsyButtonText,
  open,
  title,
  width = "small",
  data,
  seekPassLogo = /* @__PURE__ */ jsx(VerificationLogo, {}),
  onMaybeLaterClick
}) => {
  const { t } = useTranslations(translations);
  const onClick = useCallback(() => {
    if (onCertsyClick) {
      onCertsyClick();
    }
    onClose();
  }, [onCertsyClick, onClose]);
  const certsyLogo = /* @__PURE__ */ jsx(Box, { children: seekPassLogo });
  const onMaybeLaterFn = () => {
    if (onMaybeLaterClick) {
      onMaybeLaterClick();
    }
    onClose();
  };
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      id: "certsyDialog",
      illustration: certsyLogo,
      width,
      onClose,
      closeLabel: t("Close"),
      open,
      title,
      data,
      children: /* @__PURE__ */ jsxs(Stack, { space: "large", align: "center", children: [
        typeof bodyText === "string" ? /* @__PURE__ */ jsx(Text, { align: "center", children: bodyText }) : bodyText,
        /* @__PURE__ */ jsxs(Actions, { children: [
          /* @__PURE__ */ jsxs(
            ButtonLink,
            {
              href: certsyUrl,
              onClick,
              target: "_blank",
              rel: "noopener",
              role: "button",
              tone: "formAccent",
              children: [
                certsyButtonText,
                " ",
                /* @__PURE__ */ jsx(
                  IconNewWindow,
                  {
                    alignY: "lowercase",
                    title: t("Opens in a new tab"),
                    titleId: "certsyLinkIcon"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "transparent",
              tone: "formAccent",
              onClick: onMaybeLaterFn,
              children: t("Maybe later")
            }
          )
        ] })
      ] })
    }
  );
};
const PrivacyIllustration = ({
  title = "Privacy illustration"
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("title", { children: title }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M36.2525 31.5797C36.2525 25.102 41.5225 19.832 47.9998 19.832C54.4779 19.832 59.7478 25.102 59.7478 31.5797V37.0094H67.5799V31.5797C67.5799 20.7836 58.7958 12 47.9998 12C37.2038 12 28.4205 20.7836 28.4205 31.5797V37.0094H36.2526L36.2525 31.5797Z",
          fill: "#4166A4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M68.1059 37.0095H27.8941C24.5804 37.0095 21.8941 39.6958 21.8941 43.0095V78.0001C21.8941 81.3138 24.5804 84.0001 27.8941 84.0001H68.1059C71.4196 84.0001 74.1059 81.3138 74.1059 78.0001V43.0095C74.1059 39.6958 71.4196 37.0095 68.1059 37.0095Z",
          fill: "#EE399E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48 68.7539C40.2326 68.7539 36.1658 62.6033 35.0043 60.5047C36.1658 58.4062 40.2326 52.2556 48 52.2556C55.7708 52.2556 59.8375 58.4095 60.9958 60.5047C59.8343 62.6033 55.7674 68.7539 48 68.7539Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48 64.6293C50.278 64.6293 52.1246 62.7827 52.1246 60.5047C52.1246 58.2268 50.278 56.3801 48 56.3801C45.7221 56.3801 43.8754 58.2268 43.8754 60.5047C43.8754 62.7827 45.7221 64.6293 48 64.6293Z",
          fill: "#0D3880"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48 52.2556C40.2326 52.2556 36.1658 58.4062 35.0043 60.5047C36.1658 62.6033 40.2326 68.7539 48 68.7539C55.7674 68.7539 59.8343 62.6033 60.9958 60.5047C59.8375 58.4095 55.7708 52.2556 48 52.2556ZM48 64.6293C45.722 64.6293 43.8754 62.7827 43.8754 60.5047C43.8754 58.2268 45.722 56.3802 48 56.3802C50.2781 56.3802 52.1246 58.2268 52.1246 60.5047C52.1246 62.7826 50.278 64.6293 48 64.6293Z",
          fill: "white"
        }
      )
    ]
  }
);
const ResumeSensitiveDialog = ({
  onClose,
  zone,
  language,
  open,
  data,
  onTrackSensitiveInfoLink
}) => {
  const { t } = useTranslations(translations$1);
  const getUrl = useGetUrl(zone, language, true);
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      id: "resumeSensitiveDialog",
      illustration: /* @__PURE__ */ jsx(PrivacyIllustration, {}),
      width: "small",
      onClose,
      closeLabel: t("Close"),
      open,
      title: t("Protect your privacy"),
      data,
      children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
        /* @__PURE__ */ jsx(Text, { tone: "neutral", children: t("We detected potentially sensitive information in your files...") }),
        /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
          /* @__PURE__ */ jsx(Text, { tone: "neutral", weight: "strong", children: t("Sensitive information includes:") }),
          /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
            /* @__PURE__ */ jsxs(Inline, { space: "small", alignY: "center", children: [
              /* @__PURE__ */ jsx(IconLicence, { tone: "secondary" }),
              /* @__PURE__ */ jsx(Text, { tone: "neutral", children: t("Identity documents") })
            ] }),
            /* @__PURE__ */ jsxs(Inline, { space: "small", alignY: "center", children: [
              /* @__PURE__ */ jsx(IconMoney, { tone: "secondary" }),
              /* @__PURE__ */ jsx(Text, { tone: "neutral", children: t("Financial and official records") })
            ] }),
            /* @__PURE__ */ jsxs(Inline, { space: "small", alignY: "center", children: [
              /* @__PURE__ */ jsx(IconProfile, { tone: "secondary" }),
              /* @__PURE__ */ jsx(Text, { tone: "neutral", children: t("Personal and health information") })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Text, { tone: "neutral", children: t(
            "Learn more by reading our article, Sensitive information: what you need to know.",
            {
              TextLink: (v) => /* @__PURE__ */ jsx(
                TextLink,
                {
                  href: getUrl("sensitive-information"),
                  onClick: onTrackSensitiveInfoLink,
                  weight: "weak",
                  target: "_blank",
                  children: v
                }
              )
            }
          ) })
        ] })
      ] })
    }
  );
};
const focusOutlineGutter = "xxsmall";
const CertsyVerifiedIndicator = ({
  idSuffix,
  showVerifiedText = false
}) => {
  const { t } = useTranslations(translations$2);
  return /* @__PURE__ */ jsx(
    TooltipRenderer,
    {
      id: `certsy-verified-indicator-tooltip-${idSuffix}`,
      tooltip: /* @__PURE__ */ jsx(Text, { children: t("Verified by SEEK Pass") }),
      children: ({ triggerProps }) => /* @__PURE__ */ jsx(Bleed, { space: focusOutlineGutter, children: /* @__PURE__ */ jsx(
        Box,
        {
          "aria-label": t("Verified by SEEK Pass"),
          ...triggerProps,
          padding: focusOutlineGutter,
          data: {
            automation: `certsy-verified-indicator-${idSuffix}`,
            testid: `certsy-verified-indicator-${idSuffix}`
          },
          children: /* @__PURE__ */ jsxs(Text, { children: [
            /* @__PURE__ */ jsx(SeekPassIconVerified, {}),
            " ",
            showVerifiedText ? t("Verified") : null
          ] })
        }
      ) })
    }
  );
};
export {
  CertsyDialog,
  CertsyVerifiedIndicator,
  DefinitionList,
  ProfileCardDescription,
  ResumeSensitiveDialog,
  useDialogHistoryManager
};
